const DemoFBStarter_Landing4 = (props) => {
  return (
    <div className="flex flex-row justify-center bg-slate-100">
    </div>
  );
}
export default DemoFBStarter_Landing4;